<template>
    <div class="loader">
        <img src="/img/brand/logo-white.svg" alt="logo loader" />
        <v-progress-circular :size="50" indeterminate :color="'#ffb511'"></v-progress-circular>
    </div>
</template>
<script>
export default {}
</script>

<style lang="css">
.spinner,
.spinner:after {
    display: block;
    width: 32px;
    height: 32px;
    border-radius: 50%;
}
.spinner {
    background-color: transparent;
    border-top: 5px solid #ffb511;
    border-right: 5px solid #ffb511;
    border-bottom: 5px solid #ffb511;
    border-left: 5px solid #fbcc6757;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-duration: 0.8s;
    animation-name: spinner-loading;
}
@keyframes spinner-loading {
    0% {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(1turn);
    }
}
</style>
